import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { formatDate } from '../../../../../utils';
import { DEFAULT_DATE_MONTH_NAME_TIME_FORMAT } from '../../../../../constants';

import { fetchListTrainingDateOptions } from '../actions';

const TrainingDateSelect = ({ filterOptions, setFilterOptions, eventProductId, setEventProductId, isUpcoming, setIsTrainingDate }) => {
     const dispatch = useDispatch();

     const [trainingDateOptions, setTrainingDateOptions] = useState([]);

     const [isLoading, setIsLoading] = useState('');

     const fetchTrainingDateEventOptions = () => {
          dispatch(fetchListTrainingDateOptions(filterOptions, setTrainingDateOptions, setIsLoading));
     };

     const onChangeSelect = (e) => {
          const value = e ? e.value : '';
          const productIds = e ? e.productIds : '';
          if (productIds) {
               setEventProductId(productIds);
               setIsTrainingDate(true);
          } else if (!isUpcoming) {
               setEventProductId();
               setIsTrainingDate(false);
          } else {
               setIsTrainingDate(false);
          }

          const newFilter = { ...filterOptions };
          if (value) {
               newFilter.trainingDateEventId = value;
          } else {
               delete newFilter.trainingDateEventId;
          }

          setFilterOptions(newFilter);
     };

     const onMenuOpen = () => {
          fetchTrainingDateEventOptions();
     };
     return (
          <Select
               id="trainingDate"
               classNamePrefix="react-select"
               placeholder="Select Training Date Event ..."
               className="flex-1"
               options={trainingDateOptions.map((event) => {
                    return {
                         value: event.value,
                         label: formatDate({ date: event.label, timezone: event.timezone, format: DEFAULT_DATE_MONTH_NAME_TIME_FORMAT }),
                         productIds: event.productIds,
                    };
               })}
               isLoading={isLoading}
               onChange={onChangeSelect}
               onMenuOpen={onMenuOpen}
               isClearable
          />
     );
};

TrainingDateSelect.propTypes = {
     filterOptions: PropTypes.object,
     setFilterOptions: PropTypes.func,
     setEventProductId: PropTypes.func,
     eventProductId: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
     isUpComing: PropTypes.bool,
     setIsTrainingDate: PropTypes.func,
};

export default memo(TrainingDateSelect);
